import React, { useState, useEffect, Fragment } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  makeStyles,
  Container,
  CardHeader,
  Button,
  CardContent,
  Divider,
  MenuItem,
  Grid,
  InputLabel,
  TextField,
  Chip
} from '@material-ui/core';
import Page from 'src/components/Page';
import PageHeader from 'src/views/Common/PageHeader';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import { LoadingComponent } from '../../../utils/newLoader';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useAlert } from 'react-alert';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MaterialTable from "material-table";

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  }
}));

const screenCode = 'QUOTATIONCOMPLETE';

export default function QuotationCompleteListing(props) {
  const classes = useStyles();
  const navigate = useNavigate();
  const [groups, setGroups] = useState();
  const [factories, setFactories] = useState();
  const [isShowTable, setIsShowTable] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [IDDataForDefaultLoad, setIsIDDataForDefaultLoad] = useState(null);
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [statusCodes, setStatusCodes] = useState([]);
  const [isInitialLoadScreen, setIsInitialLoadScreen] = useState(false);

  const alert = useAlert();

  const [requisitionSearchDetails, setRequisitionSearchDetails] = useState({
    groupID: '0',
    FactoryID: '0',
    statusID: '0',
    supplierID: 0
  });

  const [quotationDetails, setQuotationDetails] = useState({
    groupID: '0',
    FactoryID: '0',
    supplierID: '0'
  });

  const handleClick = () => {
    navigate('/app/QuotationComplete/addEdit');
  };

  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });

  useEffect(() => {
    trackPromise(getGroupsForDropdown());
  }, []);

  useEffect(() => {
    trackPromise(getFactoriesForDropdown(), getStatusDetails());
  }, [requisitionSearchDetails.groupID]);

  useEffect(() => {
    if (
      requisitionSearchDetails.groupID !== '0' &&
      requisitionSearchDetails.FactoryID !== '0'
    ) {
      trackPromise(getSuppliersForDropDown());
    }
  }, [requisitionSearchDetails.groupID, requisitionSearchDetails.FactoryID]);

  useEffect(() => {
    const IDdata = JSON.parse(
      sessionStorage.getItem('Requisition-listing-page-search-parameters-id')
    );
    getPermissions(IDdata);
  }, []);

  useEffect(() => {
    if (IDDataForDefaultLoad != null || IDDataForDefaultLoad != undefined) {
      getRequisitionDetails();
    }
  }, [IDDataForDefaultLoad]);

  useEffect(() => {
    if (isInitialLoadScreen) {
      setRequisitionSearchDetails({
        ...requisitionSearchDetails,
        FactoryID: '0',
        statusID: '0'
      });
    }
  }, [requisitionSearchDetails.groupID]);

  useEffect(() => {
    if (isInitialLoadScreen) {
      setRequisitionSearchDetails({
        ...requisitionSearchDetails,
        statusID: '0'
      });
    }
  }, [requisitionSearchDetails.FactoryID]);

  useEffect(() => {
    if (isInitialLoadScreen) {
      setIsShowTable(false);
    }
  }, [requisitionSearchDetails.statusID]);

  useEffect(() => {
    if (isInitialLoadScreen) {
      setToDate(new Date());
      setIsShowTable(false);
    }
  }, [fromDate]);

  useEffect(() => {
    if (isInitialLoadScreen) {
      setIsShowTable(false);
    }
  }, [toDate]);

  useEffect(() => {
    sessionStorage.removeItem('Requisition-listing-page-search-parameters-id');
  }, []);

  async function getPermissions(IDdata) {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(
      p => p.permissionCode == 'VIEWQUOTATIONCOMPLETE'
    );
    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(
      p => p.permissionCode == 'GROUPDROPDOWN'
    );
    var isFactoryFilterEnabled = permissions.find(
      p => p.permissionCode == 'FACTORYDROPDOWN'
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    const initialValues = IDdata == null;
    if (initialValues) {
      setRequisitionSearchDetails({
        ...requisitionSearchDetails,
        groupID: parseInt(tokenService.getGroupIDFromToken()),
        FactoryID: permissionList.isFactoryFilterEnabled
          ? '0'
          : parseInt(tokenService.getFactoryIDFromToken())
      });
      setIsInitialLoadScreen(true);
    } else {
      setRequisitionSearchDetails({
        ...requisitionSearchDetails,
        groupID: parseInt(IDdata?.groupID),
        FactoryID: parseInt(IDdata?.FactoryID),
        statusID: parseInt(IDdata?.statusID)
      });

      setFromDate(new Date(IDdata.fromDate).toString());
      setToDate(new Date(IDdata?.toDate));
    }
    setIsIDDataForDefaultLoad(IDdata);
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroups(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(
      requisitionSearchDetails.groupID
    );
    setFactories(factories);
  }

  async function getSuppliersForDropDown() {
    try {
      const suppliers = await services.GetSuppliersByItemIDAndFactoryID(
        requisitionSearchDetails.groupID,
        requisitionSearchDetails.FactoryID
      );
      const formattedSuppliers = suppliers.map((supplier, index) => ({
        supplierID: index,
        supplierName: supplier
      }));
      setSuppliers(formattedSuppliers);
    } catch (error) {
      setSuppliers([]);
    }
  }

  async function getStatusDetails() {
    var response = await services.getStatusDetails();
    setStatusCodes(response);
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value;
    setRequisitionSearchDetails({
      ...requisitionSearchDetails,
      [e.target.name]: value
    });
    setIsShowTable(false);
  }

  function handleSearchDropdownChangeBuyer(event, value) {
    if (value) {
      setQuotationDetails(prevState => ({
        ...prevState,
        supplierID: value.supplierID,
        supplierName: value.supplierName
      }));
      setRequisitionSearchDetails(prevState => ({
        ...prevState,
        supplierID: value.supplierID
      }));
    } else {
      setQuotationDetails(prevState => ({
        ...prevState,
        supplierID: 0,
        supplierName: ''
      }));
      setRequisitionSearchDetails(prevState => ({
        ...prevState,
        supplierID: 0
      }));
    }
    setIsShowTable(false);
  }

  async function getRequisitionDetails() {
    let model = {
      groupID: parseInt(requisitionSearchDetails.groupID),
      factoryID: parseInt(requisitionSearchDetails.FactoryID),
      supplierID: parseInt(requisitionSearchDetails.supplierID),
      requisitionStatus: parseInt(requisitionSearchDetails.statusID)
    };

    const response = await services.getRequisitionDetails(model);
    if (response.statusCode == 'Success' && response.data.length > 0) {
      setTableData(response.data);
      setIsShowTable(true);
    } else {
      alert.error(response.message);
    }
    setIsIDDataForDefaultLoad(null);
    setIsInitialLoadScreen(true);
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
        <Grid item md={2} xs={12}>
          <PageHeader
            onClick={handleClick}
            isEdit={true}
            toolTiptitle={'Add Quotation Complete'}
          />
        </Grid>
      </Grid>
    );
  }

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title="Quotation Complete">
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: requisitionSearchDetails.groupID,
              FactoryID: requisitionSearchDetails.FactoryID,
              supplierID: requisitionSearchDetails.supplierID,
              statusID: requisitionSearchDetails.statusID
            }}
            validationSchema={Yup.object().shape({
              groupID: Yup.number()
                .required('Group required')
                .min('1', 'Group is required'),
              FactoryID: Yup.number()
                .required('Factory required')
                .min('1', 'Factory is required'),
              supplierID: Yup.number()
                .required('supplier required')
                .min('1', 'supplier is required')
            })}
            onSubmit={() => trackPromise(getRequisitionDetails())}
            enableReinitialize
          >
            {({ errors, handleSubmit, touched }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle('Quotation Complete')} />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent style={{ marginBottom: '2rem' }}>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(touched.groupID && errors.groupID)}
                              helperText={touched.groupID && errors.groupID}
                              fullWidth
                              name="groupID"
                              onChange={e => handleChange(e)}
                              value={requisitionSearchDetails.groupID}
                              variant="outlined"
                              size="small"
                              InputProps={{
                                readOnly: !permissionList.isGroupFilterEnabled
                              }}
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(groups)}
                            </TextField>
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="FactoryID">
                              Factory *
                            </InputLabel>
                            <TextField
                              select
                              name="FactoryID"
                              value={requisitionSearchDetails.FactoryID}
                              onChange={handleChange}
                              error={
                                touched.FactoryID && Boolean(errors.FactoryID)
                              }
                              helperText={touched.FactoryID && errors.FactoryID}
                              fullWidth
                              variant="outlined"
                              size="small"
                            >
                              <MenuItem value="0">Select Factory</MenuItem>
                              {generateDropDownMenu(factories)}
                            </TextField>
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="supplierID">
                              Item Supplier *
                            </InputLabel>
                            <Autocomplete
                              id="supplierID"
                              options={suppliers || []}
                              size="small"
                              getOptionLabel={option =>
                                option?.supplierName || ''
                              }
                              onChange={(event, value) => {
                                handleSearchDropdownChangeBuyer(event, value);
                              }}
                              value={
                                suppliers.find(
                                  supplier =>
                                    supplier?.supplierID ===
                                    quotationDetails.supplierID
                                ) || null
                              }
                              renderInput={params => (
                                <TextField
                                  {...params}
                                  error={Boolean(
                                    touched.supplierID && errors.supplierID
                                  )}
                                  helperText={
                                    touched.supplierID && errors.supplierID
                                  }
                                  variant="outlined"
                                  placeholder="--Select Supplier--"
                                />
                              )}
                            />
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="statusID">
                              Status
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(
                                touched.statusID && errors.statusID
                              )}
                              fullWidth
                              helperText={touched.statusID && errors.statusID}
                              size="small"
                              name="statusID"
                              onChange={e => {
                                handleChange(e);
                              }}
                              value={requisitionSearchDetails.statusID}
                              variant="outlined"
                            >
                              <MenuItem value="0">--Select Status--</MenuItem>
                              {generateDropDownMenu(statusCodes)}
                            </TextField>
                          </Grid>
                        </Grid>

                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            type="submit"
                            variant="contained"
                          >
                            Search
                          </Button>
                        </Box>
                      </CardContent>
                      <Box minWidth={1050}>
                        {tableData.length > 0 && isShowTable ? (
                          <MaterialTable
                            title="Multiple Actions Preview"
                            columns={[
                              {
                                title: 'Quotation Number',
                                field: 'quotationNumber',
                                type: 'string',
                                cellStyle: { textAlign: 'left', paddingLeft: '20px', verticalAlign: 'middle' },
                                headerStyle: { textAlign: 'left', paddingLeft: '20px', verticalAlign: 'middle' }
                              },
                              {
                                title: 'SKU',
                                field: 'skuMasterName',
                                type: 'string',
                                cellStyle: { textAlign: 'left', paddingLeft: '10px', verticalAlign: 'middle' },
                                headerStyle: { textAlign: 'left', paddingLeft: '10px', verticalAlign: 'middle' }
                              },
                              {
                                title: 'Unit Price',
                                field: 'unitPrice',
                                type: 'numeric',
                                cellStyle: { textAlign: 'right', paddingRight: '20px', verticalAlign: 'middle' },
                                headerStyle: { textAlign: 'right', paddingRight: '20px', verticalAlign: 'middle' },
                                render: rowData =>
                                  rowData.unitPrice != null
                                    ? rowData.unitPrice.toLocaleString('en-US', {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    })
                                    : '-'
                              },
                              {
                                title: 'Net Total',
                                field: 'netTotalPrice',
                                type: 'numeric',
                                cellStyle: { textAlign: 'right', paddingRight: '20px', verticalAlign: 'middle' },
                                headerStyle: { textAlign: 'right', paddingRight: '20px', verticalAlign: 'middle' },
                                render: rowData =>
                                  rowData.netTotalPrice != null
                                    ? rowData.netTotalPrice.toLocaleString('en-US', {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    })
                                    : '-'
                              },
                              {
                                title: 'Status',
                                field: 'quotationStatusTypeName',
                                type: 'string',
                                cellStyle: { textAlign: 'center', paddingLeft: '10px', verticalAlign: 'middle' },
                                headerStyle: { textAlign: 'center', paddingLeft: '40px', verticalAlign: 'middle' },
                                render: rowData => {
                                  const getStatusConfig = (status) => {
                                    const configs = {
                                      'Quotation Called': {
                                        bg: '#fff3e0',
                                        color: '#e65100',
                                        border: '#ffe0b2'
                                      },
                                      'Quotation Completed': {
                                        bg: '#e3f2fd',
                                        color: '#1565c0',
                                        border: '#bbdefb'
                                      },
                                      'PO Generated': {
                                        bg: '#e8f5e9',
                                        color: '#2e7d32',
                                        border: '#c8e6c9'
                                      },
                                    };
                                    return configs[status] || configs['New'];
                                  };

                                  const config = getStatusConfig(rowData.quotationStatusTypeName);

                                  return (
                                    <div
                                      style={{
                                        display: 'inline-block',
                                        backgroundColor: config.bg,
                                        color: config.color,
                                        padding: '4px 10px',
                                        borderRadius: '50px',
                                        fontWeight: '600',
                                        fontSize: '14px',
                                        border: `2px solid ${config.border}`,
                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.04)',
                                        transition: 'all 0.2s ease',
                                        cursor: 'default',
                                        whiteSpace: 'nowrap'
                                      }}
                                    >
                                      {rowData.quotationStatusTypeName}
                                    </div>
                                  );
                                }
                              }
                            ]}
                            data={tableData}
                            options={{
                              exportButton: false,
                              showTitle: false,
                              headerStyle: { height: '1%' },
                              columnResizable: false,
                              actionsColumnIndex: -1,
                              pageSize: 10
                            }}
                          />
                        ) : null}
                      </Box>
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}